import {
  RiLinkedinFill as LinkedInIcon,
  RiExternalLinkLine as OpenInNew,
  RiTwitterFill as TwitterIcon,
} from '@remixicon/react';

import { Link, Text } from '@spotify-internal/encore-web';

import { ConfidenceLogo } from '../Icons';

import styles from './Footer.module.css';

const links = {
  home: 'https://confidence.spotify.com',
  blog: 'https://confidence.spotify.com/blog',
  linkedIn: 'https://www.linkedin.com/showcase/spotify-r&d/LinkedIn',
  twitter: 'https://twitter.com/SpotifyEng',
};

export const Footer = () => (
  <footer className={styles.root}>
    <Link
      href={links.home}
      target="_blank"
      isStandalone
      className={styles.link}
      aria-label="Confidence home"
    >
      <ConfidenceLogo className={styles.logo} color="currentColor" />
      <Text as="span" variant="bodyMedium">
        Confidence
      </Text>
    </Link>

    <div className={styles.links}>
      <Link
        href={links.blog}
        target="_blank"
        isStandalone
        className={styles.link}
        aria-label="Blog"
      >
        <OpenInNew className={styles.icon} aria-hidden />
        <Text as="span" variant="bodyMedium" className={styles.label}>
          Blog
        </Text>
      </Link>
      <Link
        href={links.linkedIn}
        target="_blank"
        isStandalone
        className={styles.link}
        aria-label="LinkedIn"
      >
        <LinkedInIcon className={styles.icon} aria-hidden />
        <Text as="span" variant="bodyMedium" className={styles.label}>
          LinkedIn
        </Text>
      </Link>
      <Link
        href={links.twitter}
        target="_blank"
        isStandalone
        className={styles.link}
        aria-label="Twitter"
      >
        <TwitterIcon className={styles.icon} aria-hidden />
        <Text as="span" variant="bodyMedium" className={styles.label}>
          Twitter
        </Text>
      </Link>
    </div>
  </footer>
);
